function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 20L31 18",
  stroke: "currentcolor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-1_6094_2433",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 28.5V12.2511C32 11.0532 30.9541 10.124 29.7646 10.265L17.7646 11.6873C16.7581 11.8066 16 12.6599 16 13.6734V28.5"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29 28.5C29 30.1569 30.3431 31.5 32 31.5C33.6569 31.5 35 30.1569 35 28.5H29ZM13 28.5C13 30.1569 14.3431 31.5 16 31.5C17.6569 31.5 19 30.1569 19 28.5H13ZM17.7646 11.6873L17.4115 8.70813L17.7646 11.6873ZM29.7646 10.265L30.1177 13.2441L29.7646 10.265ZM35 28.5V12.2511H29V28.5H35ZM13 13.6734V28.5H19V13.6734H13ZM29.4115 7.28581L17.4115 8.70813L18.1177 14.6664L30.1177 13.2441L29.4115 7.28581ZM19 13.6734C19 14.1801 18.6209 14.6068 18.1177 14.6664L17.4115 8.70813C14.8953 9.00637 13 11.1396 13 13.6734H19ZM35 12.2511C35 9.25635 32.3854 6.93332 29.4115 7.28581L30.1177 13.2441C29.5229 13.3146 29 12.85 29 12.2511H35Z",
  fill: "currentcolor",
  mask: "url(#path-3-inside-1_6094_2433)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 28,
  r: 3.5,
  stroke: "currentcolor",
  strokeWidth: 3
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 28,
  r: 3.5,
  stroke: "currentcolor",
  strokeWidth: 3
});

var SvgAddMusic = function SvgAddMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-music.6fa66f1e.svg";
export { ForwardRef as ReactComponent };